titleTutorial:
    en: 'Welcome to Maxoptra — online routing and scheduling solution'
    ru: 'Добро пожаловать в Максоптра - самую мощную и одновременно доступную систему планирования транспорта и мобильных сотрудников'
    es: 'Bienvenidos a la solución online de Maxoptra de planificación y optimización  de rutas'
    fr: 'Bienvenue chez Maxoptra — Solution de routage et planification en ligne'
    pt: 'Bem-vindo ao Maxoptra — solução de planeamento de rotas'
titleUpdate:
    en: 'What''s new in the latest Maxoptra update'
    ru: 'Чего нового в системе планирования Максоптра'
    es: 'Que es Nuevo en la última actualización de Maxoptra'
    fr: 'Quoi de neuf avec la nouvelle version de Maxoptra'
    pt: 'Que novidades temos na última atualização Maxoptra'
skipBtn:
    en: Skip
    ru: Пропустить
    es: Omitir
    fr: Ignorer
    pt: Ignorar
